// extracted by mini-css-extract-plugin
export default {"container":"Comment_container__+PQBG","content":"Comment_content__FnJLn"};